export const HEIGHT = 192;

export const getHeight = (length: number) => {
  if (length === 0 || length === 1) {
    return 50;
  }

  if (length === 2) {
    return 90;
  }
  if (length === 3) {
    return 125;
  }
  if (length === 4) {
    return 165;
  }

  return HEIGHT;
};
